// extracted by mini-css-extract-plugin
export var messageSideLeft = "_m6-1";
export var messageSideRight = "_m6-2";
export var subscribeToBackInStockBubbleContainer = "_m6-0";